import $ from 'jquery'
import { CountUp } from 'countup.js'
import 'waypoints/lib/jquery.waypoints.min.js'

$(document).ready(function () {
  dhsv_vc_counter()
})

function dhsv_vc_counter() {
  $('.dhsv_vc_counter').each(function () {
    let number = $(this).find('.js-countup')
    let counter = new CountUp(number[0], number.data('number'), {
      separator: '',
    })
    number.waypoint({
      handler: direction => {
        if (direction == 'down') {
          counter.start()
        }
      },
      offset: 'bottom-in-view',
    })
  })
}
